module.exports = __webpack_public_path__ + "img/icon-share.3ba7af6e.svg";